import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / cross normal`. Do not edit by hand. */
export function CrossIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M9.54,8L15.68,14.15C16.11,14.57,16.11,15.26,15.68,15.68L15.68,15.68C15.26,16.11,14.57,16.11,14.15,15.68L8,9.54L1.85,15.68C1.43,16.11,0.74,16.11,0.32,15.68L0.32,15.68C-0.11,15.26,-0.11,14.57,0.32,14.15L6.46,8L0.32,1.85C-0.11,1.43,-0.11,0.74,0.32,0.32L0.32,0.32C0.74,-0.11,1.43,-0.11,1.85,0.32L8,6.46L14.15,0.32C14.57,-0.11,15.26,-0.11,15.68,0.32L15.68,0.32C16.11,0.74,16.11,1.43,15.68,1.85L9.54,8" />
    </svg>
  )
}
